import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import FooterBase from "./FooterBase";
import FooterMobile from "./FooterMobile";

const Footer = () => {

	const { isMobile } = useSelector(state => state.general);
    const { selectedTab } = useSelector(state => state.checkoutCart);
    const { carts } = useSelector(state => state.shoppingCart);

    return (

        <Routes>
            <Route  path='/' element={ isMobile ? <FooterMobile data={{showCart: false, selectedItem: 'home'}} /> : <FooterBase />} />
            <Route  path='/checkout/cart' element={ isMobile ? <FooterMobile data={{showCart: selectedTab === "cart" && carts.length > 0 ? true : false, selectedItem: 'cart'}} /> : <FooterBase />} />
            <Route  path='/profile/*' element={ isMobile ? <FooterMobile data={{showCart: false, selectedItem: 'profile'}} /> : null} />
            <Route  path='/categories' element={ isMobile ? <FooterMobile data={{showCart: false, selectedItem: 'categories'}} /> : null} />
            <Route  path='/category/*' element={ isMobile ? <FooterMobile data={{showCart: false}} /> : <FooterBase />} />
            <Route  path='/seller/*' element={ isMobile ? <FooterMobile data={{showCart: false}} /> : <FooterBase />} />
            <Route  path='/best-selling' element={ isMobile ? <FooterMobile data={{showCart: false}} /> : <FooterBase />} />
            <Route  path='/best-selling/*' element={ isMobile ? <FooterMobile data={{showCart: false}} /> : <FooterBase />} />
            <Route  path='/amazing-offers' element={ isMobile ? <FooterMobile data={{showCart: false}} /> : <FooterBase />} />
            <Route  path='/flash-sale' element={ isMobile ? <FooterMobile data={{showCart: false}} /> : <FooterBase />} />


            <Route  path='/courier/profile/*' element={ isMobile ? <FooterMobile data={{showCart: false}} /> : <FooterBase />} />
        </Routes>

    );
}

export default Footer;